import api from "./API";
import ApiEndpointConstants from "../constants/ApiEndpointConstants";

export const getCategoryList = (page, per_page) => {
  return api.post(`${ApiEndpointConstants.GET_CATEGORY_LIST}`, {
    page,
    per_page,
  });
};
export const getCategoryListN = () => {
  return api.post(`${ApiEndpointConstants.GET_CATEGORY_LIST_NOPAGE}`);
};
